var o = /* @__PURE__ */ ((n) => (n.Metamask = "Metamask", n.None = "", n.Okx = "OKX", n.Ronin = "Ronin", n.RoninMobile = "RoninMobile", n.WalletConnect = "WalletConnect", n))(o || {}), t = /* @__PURE__ */ ((n) => (n.Metamask = "Metamask", n.Okx = "OKX", n.Ronin = "Ronin", n.WalletConnect = "WalletConnect", n.None = "", n))(t || {}), a = /* @__PURE__ */ ((n) => (n.Metamask = "io.metamask", n.Okx = "com.okex.wallet", n.Ronin = "com.roninchain.wallet", n.WalletConnect = "walletConnect", n))(a || {});
const c = "wagmi.recentConnectorId", i = {
  name: "Apeiron",
  description: "World's 1st Godgame with NFTs",
  url: "https://www.apeironnft.com/",
  icons: ["https://www.apeironnft.com/favicon.png"]
};
export {
  c as WAGMI_RECENT_CONNECTOR_ID,
  i as WALLET_CONNECT_METADATA,
  a as WalletExtensionRdns,
  t as WalletProviderType,
  o as WalletType
};
//# sourceMappingURL=web3.js.map
